import qs from "qs"

import { client } from "@/http/client"

import { IResponse, IPagingResponse, IRequestParams } from "@/types/api"
import { BulkOrderStateRequest, BulkOrderStatus, IBulkOrder , IBulkOrderChangeStatus, IBulkOrderCreate, IBulkOrderUpdate, IBulkOrdersDelete  } from "@/types/IBulkOrder"


export interface IBulkOrderForOrderParam {
  Date: Date
}

export const getBulkOrders = (params: IRequestParams, state?: BulkOrderStateRequest): Promise<IPagingResponse<IBulkOrder>> =>
  client.get("/BulkOrder", {
    params: {
      ...params,
      state: state
    }
  })

export const getBulkOrdersSelectList = (): Promise<IResponse<IBulkOrder[]>> =>
  client.get("/BulkOrder/selectList")

export const getBulkOrderById = (id: number): Promise<IResponse<IBulkOrder>> =>
    client.get(`/BulkOrder/${id}`)

export const createBulkOrder = (
    body: IBulkOrderCreate
) : Promise<IResponse<number>> => client.post("/BulkOrder", body)

export const updateBulkOrder = (
    body: IBulkOrderUpdate
) : Promise<IResponse<number>> => client.put("/BulkOrder", body)

export const changeStatusBulkOrder = (
    body: IBulkOrderChangeStatus
) : Promise<IResponse<number>> => client.put("/BulkOrder/ChangeStatus", body)

export const deleteBulkOrders = (data:IBulkOrdersDelete): Promise<IResponse<boolean>> =>
  client.delete("/BulkOrder", { data })
